module.exports = __webpack_public_path__ + "static/media/Medidas_1_4_5_6_7.c08a677f.pdf";